<template>
    <div></div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        computed: {
            ...mapGetters([
                'getModal',
                'getModalType',
                'getModalData',
            ]),
            dialog: {
                get() {
                    return this.$store.getters.getModal
                },
                set() {
                    this.$store.commit('CLOSE_MODAL')
                },
            },
        },

        methods: {
            closeHandler() {
                this.$store.commit('CLOSE_MODAL')
            },
            async extendHandler(clientId) {
                try{
                    let data = await this.$store.dispatch('PASS_CODE_EXTEND', clientId)
                    if(data && data.status === 200) {
                        console.log(data, 'data hello world')
                        this.closeHandler()
                    }
                }catch(e) {
                    console.log(e.response)
                }
            },
            async deleteHandler(clientId) {
                try {
                    let data = await this.$store.dispatch("STUDIO_REMOVE_CLIENT", clientId)
                    if(data && data.status === 200) {
                        this.closeHandler()
                    }
                }catch(e) {
                    console.log(e, 'e')
                }
            },
            async approveHandler(clientId) {
                try {
                    let data = await this.$store.dispatch("STUDIO_APPROVE_UNVERIFIED", clientId)
                    if(data && data.status === 200) {
                        this.closeHandler()
                    }
                }catch(e) {
                    console.log(e, 'e')
                }
            },
            async declineHandler(clientId) {
                try {
                    let data = await this.$store.dispatch("STUDIO_REMOVE_CLIENT", clientId)
                    if(data && data.status === 200) {
                        this.closeHandler()
                    }
                }catch(e) {
                    console.log(e, 'e')
                }
            },

        }
    }
</script>